export default __webpack_public_path__ + "static/media/Meisse.69418a2f.jpg";